(function(args) { 

	document.getElementById(args.id).innerHTML = `
		<div class="form-field search-filter project-search-filter submit">					
	    	<a class="button-cta alt">Search</a>
	    </div>
	`;

	document.addEventListener('DOMContentLoaded', function() {
		document.addEventListener('click', function(e) {
			if (e.target.matches('.project-search-filter.submit a')) {
				e.preventDefault(); 

				var form = jQuery('#form_projects');

				form[0].action = form[0].action.split('#')[0];
		        form[0].action += '#search-projects';
		    	form[0].submit();
			} 
		});
	});

})(args);